module.exports = __webpack_public_path__ + "img/icon-retirement-active.20d57556.svg";